import apiClient from '../client.js'

export const categoriesAPI = {
  // Public category endpoints
  async getCategories(params = {}) {
    const response = await apiClient.get('/categories', { params })
    return response.data
  },

  async getCategoryTree() {
    const response = await apiClient.get('/categories/tree')
    return response.data
  },

  async getCategory(slug, params = {}) {
    const response = await apiClient.get(`/categories/${slug}`, { params })
    return response.data
  },

  // Admin category endpoints
  async getAdminCategories(params = {}) {
    const response = await apiClient.get('/admin/categories', { params })
    return response.data
  },

  async getCategoryStats() {
    const response = await apiClient.get('/admin/categories/stats')
    return response.data
  },

  async createCategory(categoryData) {
    const response = await apiClient.post('/admin/categories', categoryData)
    return response.data
  },

  async getAdminCategory(categoryId) {
    const response = await apiClient.get(`/admin/categories/${categoryId}`)
    return response.data
  },

  async updateCategory(categoryId, categoryData) {
    const response = await apiClient.put(`/admin/categories/${categoryId}`, categoryData)
    return response.data
  },

  async deleteCategory(categoryId) {
    const response = await apiClient.delete(`/admin/categories/${categoryId}`)
    return response.data
  },

  async toggleCategoryActive(categoryId) {
    const response = await apiClient.patch(`/admin/categories/${categoryId}/toggle-active`)
    return response.data
  },

  async updateSortOrder(sortOrderData) {
    const response = await apiClient.put('/admin/categories/sort-order', sortOrderData)
    return response.data
  },

  // Category Tree Builder
  async getTree() {
    const response = await apiClient.get('/admin/category-tree')
    return response.data
  },

  async addTreeEntry(data) {
    const response = await apiClient.post('/admin/category-tree', data)
    return response.data
  },

  async removeTreeEntry(id) {
    const response = await apiClient.delete(`/admin/category-tree/${id}`)
    return response.data
  },

  async reorderTree(entries) {
    const response = await apiClient.put('/admin/category-tree/reorder', { entries })
    return response.data
  }
}
